<template>
  <section style="
      padding-left: 25px;
      margin-left: 20px;
      padding-right: 10px;
      margin-right: 10px;
    ">
    <v-card class="mb-6 ml-6 mt-6 mr-2">
      <v-row style="margin: 15px">
        <v-col cols="12" sm="12" md="4" v-for="(Actitem, index) in ActualityCategoryList" v-bind:key="index">
          <v-card style="
              padding: 15px;
              background: linear-gradient(
                to right,
                rgb(231, 217, 186),
                rgb(232, 218, 185)
              );
            ">
            <v-card-title class="text-h5">
              <span style="color: #000000; font-weight: bold">{{
                Actitem.label
              }}</span>
            </v-card-title>

            <v-card-actions class="mt-2">
              <v-spacer></v-spacer>

              <v-btn @click="redirectToActualityCategorie(Actitem)" color="#00000" text>
                Voire Plus
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-card>

    <v-card class="mb-6 ml-6 mt-6 mr-2">
      <v-card-title class="d-flex align-center justify-space-between py-3 px-4">
        <div class="d-flex align-center">
          <v-icon color="primary" class="mr-2">mdi-calendar-month</v-icon>
          <span class="card-title font-weight-bold text-h6 primary--text">Calendrier des Actualités</span>
        </div>
        <div class="d-flex align-center">
          <v-btn outlined small class="mr-2" color="grey darken-2" @click="setToday">
            Aujourd'hui
          </v-btn>
          <v-btn fab text x-small color="grey darken-2" class="mr-1" @click="prev">
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
          <v-btn fab text x-small color="grey darken-2" class="mr-4" @click="next">
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>

          <v-select v-model="calendarType" :items="calendarTypes" dense outlined hide-details
            class="mr-4 select-calendar-type" style="max-width: 120px"></v-select>

          <v-btn color="primary" @click="onDateClick(null)">
            <v-icon left>mdi-plus</v-icon>
            Programmer
          </v-btn>
        </div>
      </v-card-title>

      <v-card-text>
        <div class="calendar-title-display text-h5 font-weight-medium text-center my-3 grey--text text--darken-2">
          {{ calendarTitle }}
          <div class="text-subtitle-2 grey--text mt-1" v-if="calendarStart && calendarEnd">
            Période : du {{ formatSimpleDate(calendarStart) }} au {{ formatSimpleDate(calendarEnd) }}
          </div>
        </div>
        <div class="calendar-legend d-flex flex-wrap justify-center mb-3" style="gap: 12px;">
          <div v-for="item in eventColorLegend" :key="item.page" class="d-flex align-center" style="gap: 6px;">
            <span :style="{ backgroundColor: item.color }"
              style="display: inline-block; width: 14px; height: 14px; border-radius: 50%;"></span>
            <span class="text-caption grey--text text--darken-2">{{ item.label }}</span>
          </div>
        </div>
        <v-sheet height="600" class="calendar-sheet">
          <v-calendar v-if="ActualityCategoryList.length > 0" ref="calendar" v-model="calendarFocus" color="primary" :events="scheduledEvents"
            :type="calendarType" locale="fr" :weekdays="[1, 2, 3, 4, 5, 6, 0]" @click:event="showEventDetails"
            event-more-text="{0} de plus" @click:date="onDateClick" @change="onCalendarChange"></v-calendar>
        </v-sheet>
      </v-card-text>
    </v-card>

    <v-card class="mb-6 ml-6 mt-6 mr-2">
      <v-card-title>Liste des Actualités</v-card-title>
      <v-text-field style="padding: 15px" v-model="search" append-icon="mdi-magnify" label="Search" single-line
        hide-details clearable :search="search"></v-text-field>
      <v-data-table :search="search" :loading="isLoadingTables" loading-text="Loading..." :footer-props="{
        'items-per-page-options': [5, 10, 15, 30],
      }" class="elevation-1" item-key="id" :headers="headers" :items="listActualityList" :options.sync="options"
        :server-items-length="totalActualities" @update:options="fetchActualities">
        <!-- <template v-slot:item.imgUrl="{ item }">
          <v-img
            style="margin: 10px"
            :src="item.imgUrl"
            max-width="100"
            max-height="100"
          />
          <v-divider></v-divider>
        </template> -->
        <template v-slot:[`item.imgUrl`]="{ item }">
          <v-img v-if="item.imgDBType != 'svg'" :src="item.imgUrl" width="65" height="65" />
          <div v-if="item.imgDBType === 'svg'" v-html="item.svgContent"></div>

        </template>
        <template v-slot:[`item.imgBannerUrl`]="{ item }">
          <v-img style="margin: 10px" :src="item.imgBannerDBId
            ? getImageUrlBanner(item.imgBannerDBId)
            : item.imgBannerUrl
            " width="65" height="65" />
          <v-divider></v-divider>
        </template>
        <template v-slot:[`item.actualityCategory`]="{ item }">
          {{ item.actualityCategoryEntity.label }}
        </template>
        <template v-slot:[`item.series`]="{ item }">
          {{ item.actualitySubCategoryResponse ? item.actualitySubCategoryResponse.label : "--" }}
        </template>
        <template v-slot:[`item.dateOfPublish`]="{ item }">
          {{ formatDateOfPublish(item.dateOfPublish) }}
        </template>
        <template v-slot:[`item.published`]="{ item }">
          <v-icon color="#00a325" v-if="item.published">
            {{ icons.mdiCheck }}
          </v-icon>
          <v-icon color="error" v-if="!item.published">
            {{ icons.mdiCancel }}
          </v-icon>
        </template>
        <template v-slot:[`item.isLocked`]="{ item }">
          <v-icon color="warning" v-if="item.isLocked">
            {{ icons.mdiLock }}
          </v-icon>
          <v-icon color="#00a325" v-if="!item.isLocked">
            {{ icons.mdiLockOpen }}
          </v-icon>
        </template>
        <template v-slot:[`item.modifier`]="{ item }">
          <v-icon @click="redirectToEditActuality(item)">
            {{ icons.mdiPencil }}
          </v-icon>
        </template>
        <template v-slot:[`item.supprimer`]="{ item }">
          <v-icon @click="suppressionAction(item.id)">
            {{ icons.mdiDeleteOutline }}
          </v-icon>
        </template>
      </v-data-table>
    </v-card>
    <v-row justify="center">
      <v-dialog v-model="dialogAddActuality" max-width="800">
        <v-card class="pa-6 pa-sm-6">
          <v-card-title class="headline blue darken-3 white--text mb-4 d-flex justify-space-between align-center">
            <span>Ajouter une Actualité</span>
            <v-btn icon dark @click="dialogAddActuality = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-form ref="form" lazy-validation>
            <v-card-text>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-select v-model="selectedCategoryId" :items="ActualityCategoryList" item-text="label"
                    item-value="id" label="Catégorie de l'actualité" outlined required></v-select>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-select v-model="selectedSubCategoryId" :items="selectedSubCategories" item-text="label"
                    item-value="id" label="Série de l'actualité" outlined required></v-select>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <v-text-field v-model="title" label="Titre" outlined required></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <v-text-field v-model="titleEn" label="Titre en anglais" outlined required></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <v-text-field v-model="overview" label="Overview" outlined required></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <v-text-field v-model="overviewEn" label="Overview en anglais" outlined required></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <v-text-field v-model="highlight" label="Highlight" outlined></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <v-text-field v-model="highlightEn" label="Highlight en anglais" outlined></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field v-if="highlight.length > 0" v-model="reportBy" label="Rapporté par" outlined
                    :required="isReportByRequired"></v-text-field>
                </v-col>

                <!--
                <template v-if="
                  selectedCategoryName !== 'PERSONNAGE' &&
                  selectedCategoryName !== 'PATRIMOINE' &&
                  selectedCategoryName !== 'ARTICLE'
                ">
                  <v-col cols="12" sm="12" md="6">
                    <v-text-field label="Sous-Titre" v-model="subtitle" outlined required></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="6">
                    <v-text-field label="Sous-Titre en anglais" v-model="subtitleEn" outlined required></v-text-field>
                  </v-col>
                </template>
              -->
                <template v-if="
                  selectedCategoryName !== 'PERSONNAGE' &&
                  selectedCategoryName !== 'PATRIMOINE'
                ">
                  <v-col cols="12" sm="12" md="6">
                    <VueEditor v-model="description" auto-grow outlined label="Description" placeholder="Description">
                    </VueEditor>
                  </v-col>
                  <v-col cols="12" sm="12" md="6">
                    <VueEditor v-model="descriptionEn" auto-grow outlined label="Description en anglais"
                      placeholder="Description en anglais"></VueEditor>
                  </v-col>
                </template>
                <v-col cols="12">
                  <v-text-field v-model="actualityRank" label="Rang" outlined required type="number" min="0"></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field label="Tags en francais" v-model="actualityInfo.TagsTextFr" outlined
                    required></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field label="Tags en anglais" v-model="actualityInfo.TagsTextEn" outlined
                    required></v-text-field>
                </v-col>
                <v-col cols="12" v-if="showTagsError && tagsfrList.length !== tagsEnList.length">
                  <v-alert type="error" dense class="mb-0">
                    Erreur : Le nombre de tags en français et en anglais doit être identique !
                  </v-alert>
                </v-col>
                <v-col cols="12" sm="12" md="4" v-if="title && titleEn">
                  <vue-upload-multiple-image :idUpload="imagesId" v-model="images" :data-images="images"
                    accept="image/*	" name="images" drag-text="Veuillez ajoutez une image" browse-text="Browse image"
                    primary-text="Primary image" mark-is-primary-text="Set default image" :min-image="1"
                    :multiple="false" :showEdit="false" popup-text="Description default image" drop-text="Drag and drop"
                    @upload-success="uploadImageSuccess" @before-remove="beforeRemove"
                    @images-updated="handleImagesUpdated">
                  </vue-upload-multiple-image>
                  <v-progress-linear v-if="showlowding && uploadPercentage < 100" style="max-width: 190px"
                    color="primary" indeterminate rounded height="15"><strong>{{ Math.ceil(uploadPercentage)
                    }}%</strong></v-progress-linear>
                </v-col>
                <!--
                <v-col cols="12" sm="12" md="4" v-if="
                  title &&
                  titleEn 
                ">
                  <vue-upload-multiple-image :idUpload="imagesIdBanner" v-model="imagesBanner"
                    :data-images="imagesBanner" accept="image/*	" name="imagesBanner"
                    drag-text="Veuillez ajoutez une image Banner!" browse-text="Browse image"
                    primary-text="Primary image" mark-is-primary-text="Set default image" :min-image="1"
                    :multiple="false" :showEdit="false" popup-text="Description default image" drop-text="Drag and drop"
                    @upload-success="uploadImageSuccessBanner" @before-remove="beforeRemoveBanner"
                    @images-updated="handleImagesUpdatedBanner">
                  </vue-upload-multiple-image>
                  <v-progress-linear v-if="showlowdingBanner && uploadPercentageBanner < 100" style="max-width: 190px"
                    color="primary" indeterminate rounded height="15"><strong>{{ Math.ceil(uploadPercentageBanner)
                    }}%</strong></v-progress-linear>
                </v-col>
                -->
                <v-col cols="12" sm="12" md="4">
                  <v-row align="center">
                    <v-col cols="auto" style="margin-top: 16px">
                      <span>Premium:</span>
                    </v-col>
                    <v-col cols="auto">
                      <v-switch v-model="Premium" hide-details inset></v-switch>
                    </v-col>
                    <v-col cols="auto" style="margin-top: 16px">
                      <v-icon color="#00a325" v-if="!Premium">
                        {{ icons.mdiLockOpen }}
                      </v-icon>
                      <v-icon color="warning" v-if="Premium">
                        {{ icons.mdiLock }}
                      </v-icon>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" sm="12" md="4">
                  <v-row align="center">
                    <v-col cols="auto" style="margin-top: 16px">
                      <span>certified :</span>
                    </v-col>
                    <v-col cols="auto">
                      <v-switch v-model="certified" hide-details inset></v-switch>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col v-if="certified">
                  <v-select v-model="authorSelected" clearable label="Author" :items="authorList" item-text="name"
                    item-value="id" outlined></v-select>
                </v-col>

                <v-col cols="12" sm="12" md="6">
                  <v-switch v-model="isScheduled" label="Programmer l'actualité ?" inset color="primary"></v-switch>
                </v-col>
                <v-col cols="12" sm="12" md="6" v-if="isScheduled">
                  <v-text-field type="datetime-local" outlined v-model="scheduledDateTime"
                    label="Date & Heure de programmation" :min="minDateTime" required></v-text-field>
                </v-col>
              </v-row>

            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click="ajoutactuality()" color="info darken-1"
                :disabled="!canSubmitActuality() || isButtonDisabled">
                Confirmer
              </v-btn>
              <v-btn @click="dialogAddActuality = false" color="error darken-1 error" text>
                Annuler
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
    </v-row>
    <v-row justify="center">
      <v-dialog max-width="530" v-model="dialogRemoveActuality">
        <v-card>
          <v-card-title class="text-h6">
            Etes vous sur de vouloir supprimer l'actualité ?
          </v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="deleteActuality()" color="info darken-1 " text>
              Confirmer
            </v-btn>
            <v-btn @click="dialogRemoveActuality = false" color="error darken-1 error" text>
              Annuler
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- Dialog: Détails de l'Actualité Planifiée -->
    <v-dialog v-model="detailsDialog" max-width="1000">
      <v-card v-if="selectedEvent">
        <v-card-title class="headline blue darken-3 white--text d-flex justify-space-between align-center">
          <span>Détails de l'Actualité</span>
          <v-btn icon dark @click="detailsDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pt-4">
          <v-row class="mb-2">
            <v-col cols="6">
              <div class="text-subtitle-1 font-weight-bold grey--text text--darken-3">Titre (FR) :</div>
              <div class="text-body-1">{{ selectedEvent.title }}</div>
            </v-col>
            <v-col cols="6">
              <div class="text-subtitle-1 font-weight-bold grey--text text--darken-3">Titre (EN) :</div>
              <div class="text-body-1">{{ selectedEvent.titleEn || '-' }}</div>
            </v-col>
          </v-row>
          <v-row class="mb-2">
            <v-col cols="6">
              <div class="text-subtitle-1 font-weight-bold grey--text text--darken-3">Overview :</div>
              <div class="text-body-1">{{ selectedEvent.overview || '-' }}</div>
            </v-col>
            <v-col cols="6">
              <div class="text-subtitle-1 font-weight-bold grey--text text--darken-3">Overview EN:</div>
              <div class="text-body-1">{{ selectedEvent.overviewEn || '-' }}</div>
            </v-col>
          </v-row>
          <v-row class="mb-2">
            <v-col cols="6">
              <div class="text-subtitle-1 font-weight-bold grey--text text--darken-3">subTitle (FR):</div>
              <div class="text-body-1">{{ selectedEvent.subTitle || '-' }}</div>
            </v-col>
            <v-col cols="6">
              <div class="text-subtitle-1 font-weight-bold grey--text text--darken-3">subTitle (EN):</div>
              <div class="text-body-1">{{ selectedEvent.subTitleEn || '-' }}</div>
            </v-col>
          </v-row>
          <v-row class="mb-2">
            <v-col cols="6">
              <div class="text-subtitle-1 font-weight-bold grey--text text--darken-3">description (FR):</div>
              <div class="text-body-1">{{ selectedEvent.description || '-' }}</div>
            </v-col>
            <v-col cols="6">
              <div class="text-subtitle-1 font-weight-bold grey--text text--darken-3">description (EN):</div>
              <div class="text-body-1">{{ selectedEvent.descriptionEn || '-' }}</div>
            </v-col>
          </v-row>
          <v-row class="mb-2">
            <v-col cols="6">
              <div class="text-subtitle-1 font-weight-bold grey--text text--darken-3">Date :</div>
              <div class="text-body-1">{{ selectedEvent.start }}</div>
            </v-col>
            <v-col cols="6">
              <div class="text-subtitle-1 font-weight-bold grey--text text--darken-3">Catégorie :</div>
              <v-chip color="primary" outlined small>{{ formatCategory(selectedEvent.actualityCategory) }}</v-chip>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions class="pb-4 px-6">
          <v-spacer></v-spacer>
          <v-btn v-if="!selectedEvent.published" color="error" text @click="suppressionAction(selectedEvent.id)">
            Annuler la programmation
          </v-btn>
          <v-btn color="primary" outlined @click="detailsDialog = false">
            Fermer
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </section>
</template>
<script>
import { VueEditor } from "vue2-editor/dist/vue2-editor.core.js";
import store from "../../../store/image";

import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
import {
  mdiPlus,
  mdiDeleteOutline,
  mdiPencil,
  mdiEye,
  mdiDatabasePlusOutline,
  mdiLockOpen,
  mdiLock,
  mdiCheck,
  mdiCancel,
} from "@mdi/js";
import VueUploadMultipleImage from "vue-upload-multiple-image";
import axios from "axios";
import Constant from "@/utils/constants";
import {
  FetchAllTags,
  getAllActuality,
  getAllActualityCategory,
} from "@/views/qorani/services/services";
export default {
  components: { VueUploadMultipleImage, VueEditor },
  data() {
    return {
      icons: {
        mdiPlus,
        mdiDeleteOutline,
        mdiPencil,
        mdiEye,
        mdiDatabasePlusOutline,
        mdiLockOpen,
        mdiLock,
        mdiCheck,
        mdiCancel
      },
      search: "",
      tagsArray: [],
      selectTags: [],
      dialogRemoveActuality: false,
      headers: [
        { text: "Image", value: "imgUrl" },
        { text: "Titre", value: "title" },
        { text: "Titre En anglais", value: "titleEn" },
        { text: "Catégorie", value: "actualityCategory" },
        { text: "Serie", value: "series" },
        { text: "Premium", value: "isLocked" },
        { text: "Date de publication", value: "dateOfPublish" },
        { text: "Rang", value: "actualityRank" },
        { text: "Publier", value: "published", align: "center" },
        { text: "Modifier", value: "modifier", align: "center" },
        { text: "Supprimer", value: "supprimer", align: "center" },
      ],
      listActualityList: [],
      totalActualities: 0,
      options: {},
      calendarType: "month",
      calendarTypes: [
        { text: "Mois", value: "month" },
        { text: "Semaine", value: "week" },
        { text: "Jour", value: "day" },
      ],
      calendarFocus: new Date().toISOString().slice(0, 10),
      calendarTitle: "",
      calendarStart: "",
      calendarEnd: "",
      scheduledEvents: [],
      detailsDialog: false,
      selectedEvent: null,
      selectedSubCategoryId: null,
      isLoadingTables: false,
      actualityInfo: {
        title: "",
        titleEn: "",
        overview: "",
        overviewEn: "",
        subtitle: "",
        subtitleEn: "",
        description: "",
        descriptionEn: "",
        isLocked: false,
        actualityCategoryId: "",
        actualitySubCategoryId: null,
        imgUrl: null,
        imgBannerUrl: null,
        imgUrlDBId: null,
        imgBannerUrDBlId: null,
        authorCertificateId: null,
        nbrSecondLeft: 0,
        highlight: "",
        highlightEn: "",
        reportBy: "",
        TagsTextFr: "",
        TagsTextEn: "",
      },
      dialogAddActuality: false,
      showTagsError: false,
      actualityRank:0,
      title: "",
      titleEn: "",
      overview: "",
      overviewEn: "",
      subtitle: "",
      subtitleEn: "",
      description: "",
      descriptionEn: "",
      selectedCategoryId: "",
      highlight: "",
      highlightEn: "",
      reportBy: "",
      actualitySubCategoryId: null,
      ActualityCategoryList: [],
      Premium: false,
      certified: false,
      isScheduled: false,
      scheduledDateTime: null,
      authorList: [],
      authorSelected: null,
      isButtonDisabled: false,
      imagesId: "1",
      imagesIdBanner: "0",
      uploadPercentage: null,
      uploadPercentageBanner: null,
      showlowding: false,
      showlowdingBanner: false,
      images: [],
      imagesBanner: [],
      imagesUpload: [],
      imagesUploadBanner: [],
      imageUrlBanner: "",
      imageIdBanner: null,
      imageUrl: "",
      imageId: "",
      actualityIdSupprimmer: "",
      snackbar: {
        position: "top",
        timeout: 3000,
        color: null,
        text: "",
        visible: false,
      },
      ColorList: [
        "#00BCD4",
        "#8BC34A",
        "#FF9800",
        "#9C27B0",
        "#4CAF50",
        "#795548",
        "#2196F3",
        "#E91E63",
        "#FFEB3B",
        "#607D8B"
      ],
          
    };
  },
  computed: {
    tagsfrList() {
      const rawFr = this.actualityInfo?.TagsTextFr || "";
      return rawFr
        ? rawFr.split(",").map((t) => t.trim()).filter(Boolean)
        : [];
    },
    tagsEnList() {
      const rawEn = this.actualityInfo?.TagsTextEn || "";
      return rawEn
        ? rawEn.split(",").map((t) => t.trim()).filter(Boolean)
        : [];
    },
    minDateTime() {
      const now = new Date();
      const offset = now.getTimezoneOffset();
      const localNow = new Date(now.getTime() - offset * 60 * 1000);
      return localNow.toISOString().slice(0, 16);
    },
    isReportByRequired() {
      return !!this.highlight || !!this.highlightEn;
    },
    selectedCategoryName() {
      if (!this.selectedCategoryId) return "";
      const cat = this.ActualityCategoryList.find(c => c.id === this.selectedCategoryId);
      return cat ? cat.category : "";
    },
    selectedSubCategories() {
      const category = this.ActualityCategoryList.find(
        item => item.id === this.selectedCategoryId
      )

      return category ? category.subCategoryList : []
    },
    eventColorLegend() {
      return this.ActualityCategoryList.map((pt, index) => ({
        page: pt.id,
        label: pt.label,
        color: this.ColorList[index % this.ColorList.length],
      }));
    },
  },
  methods: {
     async existTag() {
      const tagsfrList = this.tagsfrList;
      const tagsEnList = this.tagsEnList;

      if (tagsfrList.length !== tagsEnList.length) {
        this.showTagsError = true;
        console.error(
          "Erreur : Les longueurs de TagsTextFr et TagsTextEn ne sont pas égales !"
        );
        return false;
      }
      this.showTagsError = false;

      if (!this.tagsArray || this.tagsArray.length === 0) {
        this.tagsArray = (await FetchAllTags()) || [];
      }

      const tagsid = [];

      for (let i = 0; i < tagsfrList.length; i++) {
        const titleFr = tagsfrList[i];
        const titleEn = tagsEnList[i];

        const existingTag = (this.tagsArray || []).find(
          (tag) =>
            (tag.title &&
              tag.title.trim().toLowerCase() === titleFr.toLowerCase()) ||
            (tag.titleEn &&
              tag.titleEn.trim().toLowerCase() === titleEn.toLowerCase())
        );

        if (existingTag) {
          if (!tagsid.some((id) => String(id) === String(existingTag.id))) {
            tagsid.push(existingTag.id);
          }
        } else {
          try {
            const missingPayloads = {
              title: titleFr,
              titleEn: titleEn,
            };
            const response = await axios.post(
              `${Constant.QORANI}tag/add`,
              missingPayloads
            );
            if (response.data && response.data.id) {
              tagsid.push(response.data.id);
              if (this.tagsArray) {
                this.tagsArray.push(response.data);
              }
            }
          } catch (error) {
            console.error("Erreur lors de l'ajout du tag :", titleFr, error);
          }
        }
      }

      this.selectTags = [...tagsid];
      if (this.actualityInfo) {
        this.actualityInfo.listTagsIds = [...tagsid];
      }

      console.log("Tags sélectionnés pour l'ajout (IDs):", tagsid);
      return tagsid;
    },
    // Calendar Navigation and Events
    setToday() {
      this.calendarFocus = new Date().toISOString().slice(0, 10);
    },
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },
    onCalendarChange({ start, end }) {
      if (this.calendarType !== "month" || !start || !end) {
        this.calendarStart = start ? start.date : "";
        this.calendarEnd = end ? end.date : "";
      } else {
        const startDate = new Date(start.date);
        const startDayOfWeek = (startDate.getDay() + 6) % 7;
        const gridStartDate = new Date(startDate);
        gridStartDate.setDate(startDate.getDate() - startDayOfWeek);

        const endDate = new Date(end.date);
        const endDayOfWeek = (endDate.getDay() + 6) % 7;
        const gridEndDate = new Date(endDate);
        gridEndDate.setDate(endDate.getDate() + (6 - endDayOfWeek));

        const toISO = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

        this.calendarStart = toISO(gridStartDate);
        this.calendarEnd = toISO(gridEndDate);
      }
      this.$nextTick(() => {
        if (this.$refs.calendar) {
          this.calendarTitle = this.$refs.calendar.title;
        }
      });
      this.fetchCalendarEvents();
    },
    openScheduleForm(date) {
      this.dialogAddActuality = true;
      this.showTagsError = false;
      this.isScheduled = true;
      if (date) {
        const now = new Date();
        const timePart = now.toTimeString().slice(0, 5); // HH:mm
        this.scheduledDateTime = `${date}T${timePart}`;
      } else {
        const now = new Date();
        const offset = now.getTimezoneOffset();
        const localNow = new Date(now.getTime() - offset * 60 * 1000);
        this.scheduledDateTime = localNow.toISOString().slice(0, 16);
      }
    },
    onDateClick(dateObj) {
      let date = dateObj ? dateObj.date : null;
      if (date) {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const clickedDate = new Date(date);
        if (clickedDate < today) {
          return;
        }
      }
      this.openScheduleForm(date);
    },
    showEventDetails({ event }) {
      this.selectedEvent = event;
      this.detailsDialog = true;
    },
    formatSimpleDate(dateStr) {
      if (!dateStr) return "";
      try {
        const [year, month, day] = dateStr.split("-");
        return `${day}/${month}/${year}`;
      } catch (e) {
        return dateStr;
      }
    },
    formatDateOfPublish(dateTimeStr) {
      if (!dateTimeStr) return "-";
      try {
        const date = new Date(dateTimeStr);
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = String(date.getFullYear()).slice(-2);
        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");
        return `${day}:${month}:${year} ${hours}:${minutes}`;
      } catch (e) {
        return dateTimeStr;
      }
    },
    formatDateTime(dateTimeStr) {
      if (!dateTimeStr) return "-";
      try {
        const date = new Date(dateTimeStr);
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");
        return `${day}/${month}/${year} à ${hours}:${minutes}`;
      } catch (e) {
        return dateTimeStr;
      }
    },
    async fetchCalendarEvents() {
      if (!this.calendarStart || !this.calendarEnd) return;
      try {
        const response = await axios.post(Constant.QORANI + "actuality/getAllPerMonth", {
          startDate: `${this.calendarStart}T00:00:00Z`,
          endDate: `${this.calendarEnd}T23:59:59Z`
        });

        const list = response.data || [];
        this.scheduledEvents = list.map(item => {
          const dateStr = item.dateOfPublish || item.creationDate || "";
          return {
            id: item.id,
            name: item.title,
            start: dateStr.replace("T", " ").substring(0, 16),
            title: item.title,
            titleEn: item.titleEn,
            overview: item.overview,
            overviewEn: item.overviewEn,
            description: item.description,
            descriptionEn: item.descriptionEn,
            subTitle: item.subTitle,
            subTitleEn: item.subTitleEn,
            published: item.published,
            actualityCategory: item.actualityCategoryEntity.label,
            categoryId: item.actualityCategoryEntity.id,
            color: this.getEventColorForCategory(item.actualityCategoryEntity.id)
          };
        });
      } catch (error) {
        console.error("Erreur lors de la récupération des événements du calendrier:", error);
      }
    },
    getEventColorForCategory(categoryId) {
      console.log(this.ActualityCategoryList);

      const index = this.ActualityCategoryList.findIndex(cat => cat.id === categoryId);
      if (index === -1) return "#2196F3";
      return this.ColorList[index % this.ColorList.length];
    },
    async loadImage(item) {
      if (item.imgDBType === "svg") {
        try {
          const response = await fetch(
            `${Constant.QORANI}fileDB/files/${item.imgDBId}`
          );
          let svgContent = await response.text();
          svgContent = svgContent
            .replace(/(<svg[^>]*)\swidth="[^"]*"/i, "$1")
            .replace(/(<svg[^>]*)\sheight="[^"]*"/i, "$1")
            .replace(/(<svg[^>]*)>/i, '$1 width="65" height="65">');

          this.$set(item, 'svgContent', svgContent);

        } catch (error) {
          console.error("Erreur lors du chargement de l'image :", error);
        }
      } else {
        this.$set(item, 'imgUrl', `${Constant.QORANI}fileDB/files/${item.imgDBId}`);
      }
      return item;
    },
    getImageUrl(imgDBId) {
      return `${Constant.QORANI}fileDB/files/${imgDBId}`;
    },
    getImageUrlBanner(imgBannerDBId) {
      return `${Constant.QORANI}fileDB/files/${imgBannerDBId}`;
    },
    redirectToActualityCategorie(item) {
      this.$router.push({
        name: "ActualityCategorie",
        params: { id: item.id, category: item.category },
      });
    },
    redirectToEditActuality(item) {
      this.$router.push({
        name: "EditActuality",
        params: { id: item.id, item: item },
      });
    },
    async deleteActuality() {
      const response = await fetch(
        Constant.QORANI + `actuality/delete/${this.actualityIdSupprimmer}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      try {
        window.location.reload();
      } catch (error) {
        alert(
          "Une erreur est survenue lors de la suppression du juz, veuillez réessayez plus tard, Merci."
        );
        this.dialogRemoveActuality = false;
      }
    },
    suppressionAction(item) {
      this.actualityIdSupprimmer = item;
      // this.dialogRemoveActuality = true;
      this.deleteActuality();
    },

    formatCategory(inputString) {
      if (!inputString) return "";
      const words = inputString.toLowerCase().split("_");
      const capitalizedWords = words.map(
        (word) => word.charAt(0).toUpperCase() + word.slice(1)
      );
      return capitalizedWords.join(" ");
    },
    beforeRemove(index, done, fileList) {
      this.showlowding = false;
      this.uploadPercentage = 0;
      const r = confirm("remove image");
      if (r === true) {
        const indexInArrayImages = this.imagesUpload.indexOf(
          fileList[index].path
        );
        this.imageUrl = "";
        this.imageId = "";
        if (index > -1) {
          this.imagesUpload.splice(indexInArrayImages, 1);
        }
        done();
      }
    },
    beforeRemoveBanner(index, done, fileList) {
      this.showlowdingBanner = false;
      this.uploadPercentageBanner = 0;
      const r = confirm("remove image");
      if (r === true) {
        const indexInArrayImages = this.imagesUploadBanner.indexOf(
          fileList[index].path
        );
        this.imageUrlBanner = "";
        this.imageIdBanner = "";
        if (index > -1) {
          this.imagesUploadBanner.splice(indexInArrayImages, 1);
        }
        done();
      }
    },
    async uploadImageSuccess(formData, index, fileList) {
      try {
        await store.dispatch("uploadImageSuccess", {
          formData,
          index,
          fileList,
        });
        const imageId = store.state.imageId;
        this.actualityInfo.imgUrlDBId = imageId;
        this.actualityInfo.imgBannerUrDBlId = imageId;

      } catch (error) {
        console.error("Failed to upload image:", error);
      }
    },
    async uploadImageSuccessBanner(formData, index, fileList) {
      try {
        await store.dispatch("uploadImageSuccessBanner", {
          formData,
          index,
          fileList,
        });
        const imageIdBanner = store.state.imageIdBanner;
        this.actualityInfo.imgBannerUrDBlId = imageIdBanner;
      } catch (error) {
        console.error("Failed to upload image:", error);
      }
    },
    handleImagesUpdated(images) {
    },
    handleImagesUpdatedBanner(imagesBanner) {
    },
    async fetchActualities() {
      this.isLoadingTables = true;
      const { page, itemsPerPage } = this.options;
      try {
        const response = await axios
          .post(Constant.QORANI + "actuality/getAllPaginate", {
            pageNumber: (page || 1) - 1,
            pageSize: itemsPerPage || 5,
            onlyPublished: false
          });
        const data = response.data || {};
        this.listActualityList = data.actualityResponseList || [];
        this.totalActualities = data.totalElementNumber || 0;

        this.listActualityList.forEach(async (item) => {
          if (item.imgDBId) {
            await this.loadImage(item);
          }
        });
      } catch (error) {
        console.error("Erreur lors de la récupération des actualités:", error);
      } finally {
        this.isLoadingTables = false;
      }
    },
    canSubmitActuality() {
      if (!this.actualityInfo.imgUrlDBId) return false;
      if (!this.actualityInfo.imgBannerUrDBlId) return false;
      if (!this.title?.trim() || !this.titleEn?.trim()) return false;
      if (!this.overview?.trim() || !this.overviewEn?.trim()) return false;

      const categoryName = this.selectedCategoryName || '';
      if (!['PERSONNAGE', 'PATRIMOINE'].includes(categoryName)) {
        if (!this.description?.trim() || !this.descriptionEn?.trim()) return false;
      }
      
      if (this.isScheduled && !this.scheduledDateTime) return false;
      if ((this.highlight?.trim() || this.highlightEn?.trim()) && !this.reportBy?.trim()) return false;
      if (this.certified && !this.authorSelected) return false;

      return true;
    },
    async ajoutactuality() {
      if (!this.canSubmitActuality()) return;

      const tagSyncSuccess = await this.existTag();
      if (tagSyncSuccess === false) {
        return;
      }

      let nbrSecondLeft = 0;
      if (this.isScheduled) {
        const dateTime = new Date(this.scheduledDateTime);
        const scheduledTimestamp = Math.floor(dateTime.getTime() / 1000);
        const unixTimestamp = Math.floor(Date.now() / 1000);
        nbrSecondLeft = scheduledTimestamp - unixTimestamp;
      }
      this.actualityInfo.title = this.title;
      this.actualityInfo.titleEn = this.titleEn;
      this.actualityInfo.overview = this.overview;
      this.actualityInfo.overviewEn = this.overviewEn;
      this.actualityInfo.subtitle = this.title;
      this.actualityInfo.subtitleEn = this.titleEn;
      this.actualityInfo.description = this.description;
      this.actualityInfo.descriptionEn = this.descriptionEn;
      this.actualityInfo.isLocked = this.Premium;
      this.actualityInfo.actualityCategoryId = this.selectedCategoryId;
      this.actualityInfo.actualitySubCategoryId = this.selectedSubCategoryId;
      this.actualityInfo.authorCertificateId = this.authorSelected;
      this.actualityInfo.nbrSecondLeft = this.isScheduled ? nbrSecondLeft : 0;
      this.actualityInfo.listTagsIds = this.selectTags;
      this.isButtonDisabled = true;
      this.actualityInfo.highlight = this.highlight;
      this.actualityInfo.highlightEn = this.highlightEn;
      this.actualityInfo.reportBy = this.reportBy;
      this.actualityInfo.actualityRank = this.actualityRank;

      try {
        const response = await fetch(Constant.QORANI + "actuality/add", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(this.actualityInfo),
        });

        if (response.ok) {
          window.location.reload();
        } else {
          alert("Une erreur est survenue lors de l'ajout de l'actualité.");
          this.isButtonDisabled = false;
        }
      } catch (error) {
        alert("Une erreur est survenue lors de l'ajout de l'actualité.");
        this.isButtonDisabled = false;
      }
    },
  },
  async created() {
    this.isLoadingTables = true;
    Promise.all([
      axios.get(`${Constant.QORANI}authorCertificate/getall`),
      getAllActualityCategory(),
      FetchAllTags()
    ]).then(([responseAuthor, actualityCategoryList, tagsArray]) => {
      this.authorList = responseAuthor.data;
      this.ActualityCategoryList = actualityCategoryList;
      this.tagsArray = tagsArray;
    }).catch((error) => {
      console.error(error);
    }).finally(() => {
      this.isLoadingTables = false;
    });
  },
};
</script>

<style lang="css">
@import "~vue2-editor/dist/vue2-editor.css";

/* Import the Quill styles you want */
@import "~quill/dist/quill.core.css";
@import "~quill/dist/quill.bubble.css";
@import "~quill/dist/quill.snow.css";

.transparent-card {
  padding-right: 15px;
  margin-right: 15px;
  margin-left: 15px;
  margin-top: 5px;
  margin-bottom: 5px;
  background-color: transparent !important;
}
</style>
